import React from 'react';
import './OurTeamPage.css';

const HeroBlock = ({ label, title, text, image, chipOne = 'Live Tracking', chipTwo = '24/7 Control Room' }) => (
  <section className="enhanced-hero team-hero-section" style={{ backgroundImage: `url(${image})` }}>
    <div className="container enhanced-hero-grid">
      <div className="enhanced-copy reveal-left">
        <span className="section-label eyebrow-dark">{label}</span>
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{text}</p>
        <div className="hero-actions">
          <a href="/contact-us" className="btn btn-primary">Get Free Consultation</a>
          <a href="/packages" className="btn btn-outline">View Packages</a>
        </div>
        <div className="hero-metrics">
          <span><strong>Sales</strong>Customer Guidance</span>
          <span><strong>Ops</strong>Testing & Support</span>
          <span><strong>24/7</strong>Recovery Team</span>
        </div>
      </div>
    </div>
  </section>
);

const ceo = {
  name: 'Shahid Nawaz',
  role: 'Chief Executive Officer',
  department: 'Leadership',
  image: '/dts-assets/team/shahid-nawaz.jpg',
  email: 'info@dtrackings.com',
  phone: '+92 301 2062029',
};

const teamMembers = [
  {
    name: 'Muhammad Junaid Nawaz',
    role: 'Regional Manager (Punjab)',
    department: 'Regional Sales',
    image: '/dts-assets/team/muhammad-junaid-nawaz.jpg',
    email: 'junaid.nawaz@dtrackings.com',
    phone: '03058134242',
  },
  {
    name: 'Muhammad Usman Tariq',
    role: 'Chief Operating Officer',
    department: 'Operations Leadership',
    image: '/dts-assets/team/muhammad-usman-tariq.jpg',
    email: 'm.usmantariq@dtrackings.com',
    phone: '+923162575827',
  },
  {
    name: 'Muhammad Rafiq Baloch',
    role: 'Security & Recovery Department Head',
    department: 'Security & Recovery',
    image: '/dts-assets/team/muhammad-rafiq-baloch.jpg',
    email: '',
    phone: '0300-7034953',
  },
  {
    name: 'Mrs. Seemab Alam',
    role: 'Sales Manager',
    department: 'Sales Department',
    image: '/dts-assets/team/mrs-seemab-alam.jpg',
    email: 'sales1@dtrackings.com',
    phone: '',
  },
  {
    name: 'Maryam Hussain',
    role: 'Testing & Operations Department',
    department: 'Testing & Operations',
    image: '/dts-assets/team/maryam-hussain.jpg',
    email: 'operations@dtrackings.com',
    phone: '',
  },
];

const departments = [
  ['Sales & Consultation', 'Guiding customers toward the right personal and corporate tracking packages.'],
  ['Testing & Operations', 'Ensuring devices, alerts, dashboards, and installation workflows are properly coordinated.'],
  ['Security & Recovery', 'Supporting theft alerts, recovery coordination, and control room escalation.'],
  ['Customer Support', 'Handling ongoing communication, service requests, and after-sales assistance.'],
];

const OurTeamPage = () => (
  <main className="enhanced-page team-enhanced">
    <HeroBlock
      label="Our Team"
      title="Meet the People Behind <em>Dynamic Tracking</em>"
      text="Our team brings together leadership, sales, operations, testing, security, and recovery expertise to deliver dependable GPS tracking and fleet management services across Pakistan."
      image="/dts-assets/ai/team-hero.png"
      chipOne="Professional Team"
      chipTwo="Customer Support"
    />

    <section className="enhanced-section ceo-highlight-section">
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label">Leadership Spotlight</span>
          <h2>Leadership That Sets the <em>Direction</em></h2>
          <div className="divider" />
          <p>Our executive leadership drives the standards, customer trust, and service quality behind DTS.</p>
        </div>

        <div className="ceo-highlight-card reveal">
          <div className="ceo-highlight-image-wrap">
            <img src={ceo.image} alt={ceo.name} className="ceo-highlight-image" />
          </div>
          <div className="ceo-highlight-copy">
            <span className="member-dept">{ceo.department}</span>
            <h3>{ceo.name}</h3>
            <p className="ceo-highlight-role">{ceo.role}</p>
            <p>Leading Dynamic Tracking Solutions with a strong focus on security, operational excellence, innovation, and long-term customer trust across Pakistan.</p>
            <div className="ceo-highlight-meta">
              <a href={`mailto:${ceo.email}`}>{ceo.email}</a>
              <a href={`tel:${ceo.phone.replace(/[^+0-9]/g, '')}`}>{ceo.phone}</a>
            </div>
            <div className="ceo-highlight-actions">
              <a href="/ceo-message" className="btn btn-primary">Read CEO Message</a>
              <a href="/contact-us" className="btn btn-outline">Contact Leadership</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="enhanced-section alt team-members-section">
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label">Core Team</span>
          <h2>Experienced Professionals, <em>One Mission</em></h2>
          <div className="divider" />
          <p>Each department works together to keep customers connected, informed, and protected.</p>
        </div>

        <div className="member-grid">
          {teamMembers.map((member, index) => (
            <article className="member-card reveal" style={{ transitionDelay: `${index * 70}ms` }} key={member.name}>
              <div className="member-photo-wrap">
                <img src={member.image} alt={member.name} className="member-photo" />
              </div>
              <div className="member-info">
                <span className="member-dept">{member.department}</span>
                <h3>{member.name}</h3>
                <p className="member-role">{member.role}</p>
                <div className="member-lines">
                  {member.email && <a href={`mailto:${member.email}`}>{member.email}</a>}
                  {member.phone && <a href={`tel:${member.phone.replace(/[^+0-9]/g, '')}`}>{member.phone}</a>}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="enhanced-section dark-band team-dept-band">
      <div className="container process-grid">
        {departments.map((item, index) => (
          <div className="process-card reveal" key={item[0]}>
            <span>{index + 1}</span>
            <h3>{item[0]}</h3>
            <p>{item[1]}</p>
          </div>
        ))}
      </div>
    </section>
  </main>
);

export default OurTeamPage;
